import { useCallback, useState } from 'react';
import { get } from 'lodash';

async function registerMembership(client, data) {
  const query = `
    mutation($data: RegisterMembershipInput!) {
      register: registerMembership(
        input: $data
      ) {
        result: registerMembershipResult {
          membership {
            id
            userId
            address
            phone
            memberCode
            groupCode
            grpUniqueCode
            duration {
              end {
                value
              }
            }
            group: groupByGroupId {
              id
              name
            }
          }
          user {
            id
            firstName
            lastName
            email
            phone
            address
          }
        }
      }
    }
  `;
  const result = await client.request(query, { data: { ...data, useOldUser: false } });
  const membership = get(result, 'register.result.membership', {});
  const user = get(result, 'register.result.user', {});
  return {
    ...membership,
    user,
  };
}

export default function useRegister({ client }) {
  const [registerResult, setRegisterResult] = useState(null);
  const register = useCallback((data) => {
    if (client) {
      registerMembership(client, data)
        .then(result => setRegisterResult({ success: true, data: result }))
        .catch(e => setRegisterResult({ success: false, message: e.message, data: e }));
    }
  }, [client]);
  return {
    register,
    registerResult,
    clearRegisterResult() { setRegisterResult(null); },
  };
}
